import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandProcurementPlanMasterFormOptions } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetDemandProcurementPlanMasterFormOptionsRequestSchema,
  type GetDemandProcurementPlanMasterFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要調達計画マスタ form 選択肢を集約 RPC で取得する hook。
 *
 * BFF が小売/自己託送区分でフィルタ済みの bgs を返す。
 * cache key は RPC 定義のみ (area param は持たない、area narrow は client-side)。
 */
export function useGetDemandProcurementPlanMasterFormOptions(): UseQueryResult<
  GetDemandProcurementPlanMasterFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getDemandProcurementPlanMasterFormOptions,
    create(GetDemandProcurementPlanMasterFormOptionsRequestSchema, {}),
  )
}
